"use client";

import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { AUTH_SESSION_KEYS } from "@/constants/auth-session-keys";
import { Header } from "../../components/header";
import { OtpCard } from "../../components/otp-card";

const routeApi = getRouteApi("/auth/verify");

export const OtpVerifyPage = () => {
  const navigate = useNavigate();
  const searchParams = routeApi.useSearch();
  const page = searchParams.page;
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem(AUTH_SESSION_KEYS.OTP_TOKEN);
    setHasToken(!!token);
    if (!token) {
      navigate({
        to: "/auth/login"
      });
    }
  }, [navigate]);

  if (!hasToken) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="flex justify-center items-center h-full">
        <OtpCard page={page} />
      </div>
    </>
  );
};
